import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-black">
      <div className="noise-overlay" />
      
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md border-b border-[#262626]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex justify-between items-center">
          <Link to="/" className="font-heading text-xl font-bold tracking-tight text-[#C9A84C]">
            SAC CITY SHINE
          </Link>
          <Link to="/" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2">
            <ArrowLeft className="h-4 w-4" />
            Back to Home
          </Link>
        </div>
      </nav>

      <div className="pt-24 pb-16 px-6 md:px-12 lg:px-24">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-white mb-8" data-testid="privacy-title">
            Privacy Policy
          </h1>
          
          <div className="prose prose-invert max-w-none space-y-6 text-gray-300">
            <p>
              Sac City Shine respects your privacy. When you book a service or contact us through our website, we may collect your name, phone number, email address, and service details.
            </p>
            
            <p>
              This information is used only to schedule appointments, provide service updates, and communicate regarding your booking.
            </p>
            
            <p>
              Mobile information will not be shared with third parties or affiliates for marketing or promotional purposes. All SMS consent information remains confidential.
            </p>
            
            <p>
              We do not sell or distribute your personal information.
            </p>
            
            <p>
              If you have questions about this policy, please contact Sac City Shine directly.
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="py-8 px-6 md:px-12 lg:px-24 bg-black border-t border-[#262626]">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">© {new Date().getFullYear()} Sac City Shine. Sacramento, CA.</p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="text-gray-500 hover:text-white text-sm transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-gray-500 hover:text-white text-sm transition-colors">Terms & Conditions</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
